import { render, staticRenderFns } from "./InitForm.vue?vue&type=template&id=6e633faf&scoped=true"
import script from "./InitForm.vue?vue&type=script&lang=js"
export * from "./InitForm.vue?vue&type=script&lang=js"
import style0 from "./InitForm.vue?vue&type=style&index=0&id=6e633faf&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e633faf",
  null
  
)

export default component.exports